import React from "react";
import dayjs from "dayjs";
import { KeyValueList, Badge, Text } from "@tv2no/ui-react";

export const ImportDetails = ({ entry }) => {
    return (
        <KeyValueList>
            <KeyValueList.Item label="Status">
                {entry.finished ? (
                    <Badge icon="refresh" color="success">
                        Fullført
                    </Badge>
                ) : (
                    <Badge color="info">Importerer</Badge>
                )}
            </KeyValueList.Item>

            <KeyValueList.Item label="Skatteår">{entry.year}</KeyValueList.Item>
            <KeyValueList.Item label="Datagrunnlag">
                {entry.fileData ? (
                    <span>
                        {entry.fileData.name}{" "}
                        <Badge color="silent" leftSpacing>
                            {entry.fileData.version}
                        </Badge>
                    </span>
                ) : null}
            </KeyValueList.Item>
            <KeyValueList.Item label="Leste / gyldige rader">
                <Text semiBold>{entry.linesReadCount}</Text> / {entry.linesProcessedCount}
            </KeyValueList.Item>

            {entry.externalCallsTotal ? (
                <KeyValueList.Item label="Eksterne geo-oppslag">
                    <Text>{entry.externalCallsTotal}</Text>
                </KeyValueList.Item>
            ) : null}

            {entry.searchBulkTotal ? (
                <KeyValueList.Item label="Søkindeksering (total/suksess/feilet)">
                    <Text semiBold>{entry.searchBulkTotal}</Text> /{" "}
                    <Text success>{entry.searchBulkSuccess + ""}</Text> /{" "}
                    <Text error>{entry.searchBulkFailed + ""}</Text>
                </KeyValueList.Item>
            ) : null}

            {entry.listUploadsTotal ? (
                <KeyValueList.Item label="Geo-lister (total/suksess/feilet)">
                    <Text semiBold>{entry.listUploadsTotal}</Text> /{" "}
                    <Text success>{entry.listUploadsSuccess + ""}</Text> /{" "}
                    <Text error>{entry.listUploadsFailed + ""}</Text>
                </KeyValueList.Item>
            ) : null}

            {entry.personListEntries ? (
                <KeyValueList.Item label="Personlister (rader/multiple/mangler)">
                    <Text semiBold>{entry.personListEntries}</Text> /{" "}
                    <Text warning>{entry.personListMultiple + ""}</Text> /{" "}
                    <Text error>{entry.personListMissing + ""}</Text>
                </KeyValueList.Item>
            ) : null}

            <KeyValueList.Item label="Startet">
                {entry.started ? dayjs(entry.started).format("LL - HH:mm:ss") : null}
            </KeyValueList.Item>

            {entry.finished ? (
                <KeyValueList.Item label="Fullført">
                    {entry.finished ? dayjs(entry.finished).format("LL - HH:mm:ss") : null}
                </KeyValueList.Item>
            ) : null}

            <KeyValueList.Item label="Varighet">
                {entry.duration != null ? `${Math.round(entry.duration / 1000)} sek` : null}
            </KeyValueList.Item>
            <KeyValueList.Item label="Testkjøring">
                {entry.dryRun ? <Text color="info">Ja</Text> : <Text>Nei</Text>}
            </KeyValueList.Item>
            <KeyValueList.Item label="Parser">{entry.parserType}</KeyValueList.Item>
        </KeyValueList>
    );
};
